<!-- 培训计划草稿箱 -->
<template>
    <div id="train-draft">
        <el-tooltip class="item" effect="dark" content="保存到草稿箱" placement="left" :hide-after="1000">
            <el-button @click="save" class="btn-save" type="success" :disabled="!trainName"
                       icon="el-icon-box" size="medium"></el-button>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="打开草稿箱" placement="left" :hide-after="1000">
            <el-button @click="openDraft" class="btn-draft" type="primary" icon="el-icon-sold-out" size="medium"></el-button>
        </el-tooltip>

        <el-drawer
            :append-to-body="false"
            :modal-append-to-body="false"
            class="train-draft-drawer"
            title="培训计划草稿箱"
            :visible.sync="drawer"
            @closed="drawerClosed">
            <div class="tips">
                <p>- 这里会展示最近的5个草稿</p>
                <p>- 选择草稿进行恢复（注意：会覆盖已填充的数据）</p>
            </div>
            <div class="draft-list">
                <div class="draft-item" @click="selectDraft(item.id)" v-for="(item, index) in draftData" :key="item.id"
                    :class="{'active': selectedID === item.id}">
                    <template v-if="item.data">
                        <div class="item-header">
                            <div class="item"><span class="item">{{item.data.name}}</span></div>
                        </div>

                        <div class="item-body">
                            <div class="item">保存时间：<span class="item">{{item.time}}</span></div>

                            <div class="item">
                                参训人员：
                                <span class="item">{{item.data.trainees.length}}人</span>

                                <span v-if="item.data.trainees.length">
                                    <el-tag v-for="v in item.data.trainees.slice(0,10)" :key="v.id" size="mini" type="primary">
                                        {{v.name}}
                                    </el-tag>
                                    <el-tag size="mini" type="primary" v-if="item.data.trainees.length>10">...</el-tag>
                                </span>
                            </div>
                            <div class="item item-course">
                                课程体系：
                                <template v-if="item.data.processes.length" v-for="c in item.data.processes">
                                    <span v-if="c.resType===1" class="course"><i class="nucfont inuc-folder-ppt"></i> {{c.title}}</span>
                                    <span v-else-if="c.resType===2" class="paper"><i class="nucfont inuc-kaoshijilu"></i> {{c.title}}</span>
                                    <span v-else-if="c.resType===3" class="mock"><i class="nucfont inuc-mockpaper"></i> {{c.title}}</span>
                                    <span v-else-if="c.resType===4" class="survey"><i class="nucfont inuc-feedback"></i> {{c.name || c.businessName}}</span>
                                </template>
                                <span v-if="!item.data.processes.length" class="item">未设置</span>
                            </div>
                        </div>
                    </template>
                    <i @click="delDraft(index)" class="el-icon-error btn-del"></i>
                </div>
            </div>

            <div class="btn-wrap">
                <el-button @click="recover" type="primary" size="medium" :disabled="!selectedID">恢复</el-button>
            </div>
        </el-drawer>
    </div>
</template>

<script>
    import {Storage, Ticket, findComponentUpward} from "@/utils"
    import dayjs from 'dayjs'

    export default {
        name: 'trainDraft',
        components: {},
        data() {
            return {
                uuid: '',
                draftData: [],
                drawer: false,
                selectedID: 0,
            }
        },
        computed: {
            userID() {
                return Ticket.get() && Ticket.get().userID
            },
            // 存在本地的draft的key
            keys() {
                return `trainDraft-${this.userID}`
            },
            trainName() {
                let parent = findComponentUpward(this, 'addTrainPlan')
                let stepForm = parent.$refs.stepForm
                return stepForm.ruleForm?.name
            },
        },
        mounted() {
            this.uuid = new Date().getTime()

            this.draftData = Storage.get(this.keys) || []
        },

        methods: {
            save() {
                let data = this.getSubmitData()

                let index = this.draftData.findIndex(item => item.id === this.uuid)
                if (index > -1) {
                    this.draftData[index] = {
                        id: this.uuid,
                        time: dayjs().format('YYYY-MM-DD HH:mm:ss'),
                        data
                    }
                } else {
                    this.draftData.push({
                        id: this.uuid,
                        time: dayjs().format('YYYY-MM-DD HH:mm:ss'),
                        data
                    })
                }

                this.$message.success('保存成功！')

                this.draftData = this.controlDraftNum()
                Storage.set(this.keys, this.draftData)
            },

            getSubmitData() {
                let $parent = findComponentUpward(this, 'addTrainPlan')
                let $stepMember = $parent.$refs.stepMember
                let $stepCourse = $parent.$refs.stepCourse

                let rawData = $parent.getSubmitData()
                let data = {...rawData}

                data.trainees = $stepMember.multipleSelection
                let processes = $stepCourse.courseArray.map(item => {
                    let setting = {}
                    if (item.resType === 1) {
                        setting = data.processes.find(process => item.courseID === process.courseID)
                    } else if (item.resType === 2) {
                        setting = data.processes.find(process => item.paperID === process.paperID)
                    } else if (item.resType === 3) {
                        setting = data.processes.find(process => item.mockPaperID === process.mockPaperID)
                    } else if (item.resType === 4) {
                        setting = data.processes.find(process => item.businessId === process.businessId)
                    }

                    return {...item,...setting}
                })

                data.processes = processes

                return data
            },

            // 保持同一个人存在本地的draft为前5个最新的
            controlDraftNum() {
                return this.draftData.sort((a, b) => b.id - a.id).slice(0,5)
            },

            openDraft() {
                this.drawer = true
                console.log(this.draftData)
            },
            selectDraft(id) {
                if (this.selectedID === id) {
                    this.selectedID = 0
                } else {
                    this.selectedID = id
                }
            },
            delDraft(index) {
                this.draftData.splice(index, 1)
                Storage.set(this.keys, this.draftData)
            },
            recover() {
                let draft = this.draftData.find(v => v.id === this.selectedID)

                this.$emit('submit', draft.data)

                let $parent = findComponentUpward(this, 'addTrainPlan')
                let $stepMember = $parent.$refs.stepMember

                if ($stepMember.tableData.length) {
                    $stepMember.updateSelectStatus()
                } else {
                    let unwatch = $stepMember.$watch('tableData', (v) => {
                        if (v.length) {
                            $stepMember.updateSelectStatus()
                            unwatch()
                        }
                    })
                }

                this.$message.success('恢复成功')

                // 恢复完了删除该草稿
                let index = this.draftData.findIndex(v => v.id === this.selectedID)
                this.delDraft(index)

                this.drawer = false
            },

            drawerClosed() {
                this.selectedID = 0
            }
        },

    }
</script>

<style lang="scss">
    @import "~@/style/const";

    #train-draft {
        position: absolute;
        top: 40%;
        right: 8px;
        z-index: 100;

        .btn-save, .btn-draft {
            display: block;
            margin: 0;
            i {
                font-size: 18px;
            }
        }

        .btn-save {
            border-radius: 4px 4px 0 0;
            border-bottom: 1px solid hsla(0,0%,100%,.5);
        }

        .btn-draft {
            border-top: 1px solid hsla(0,0%,100%,.5);
            border-radius: 0 0 4px 4px;
        }

        .train-draft-drawer {
            .el-drawer {
                width: 360px !important;
                @include scrollbar();
            }
            .el-drawer__body {
                padding: 0 20px 20px 20px;
                overflow: hidden;
                display: flex;
                flex-direction: column;
            }
            .el-drawer__header {
                margin-bottom: 20px;
                color: #333;
                font-weight: 600;
            }
            .tips {
                padding-left: 10px;
                font-size: 13px;
                color: #9f9f9f;
                p {
                    line-height: 1.6;
                }
            }

            .draft-list {
                flex: 1;
                overflow: auto;
                padding: 0 5px;
                margin-top: 10px;
                font-family: "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
            }

            .draft-item {
                position: relative;
                margin-bottom: 15px;
                border: 1px solid #ddd;
                border-radius: 6px;
                transition: all .15s;
                cursor: pointer;

                .item-header {
                    padding: 8px 15px;
                    color: #666;
                    font-weight: 600;
                    border-bottom: 1px solid #ddd;
                }

                .item-body {
                    padding: 10px 15px;
                }

                .item {
                    line-height: 1.6;
                    + .item {
                        margin-top: 6px;
                    }
                    .el-tag {
                        margin-left: 4px;
                    }
                }

                .item-course {
                    span {
                        margin-right: 8px;
                        border-bottom: 1px solid #ccc;
                    }
                    .course {
                        color: $c-course;
                    }
                    .paper {
                        color: $c-paper;
                    }
                    .mock {
                        color: $c-mock;
                    }
                    .survey {
                        color: #909399;
                    }
                }

                .btn-del {
                    position: absolute;
                    right: 4px;
                    top: 0;
                    padding: 8px;
                    font-size: 22px;
                    color: #f56c6c;
                    transition: all .3s;
                    opacity: 0;
                    &:hover {
                        color: darken(#f56c6c,10%);
                        transform: scale(1.1);
                    }
                }
                &:hover {
                    border-color: $color-theme;
                    background-color: #ecf9ff;
                    .btn-del {
                        opacity: 1;
                    }
                }
                &.active {
                    border-color: $color-theme;
                    background-color: #ecf9ff;
                }
            }

            .btn-wrap {
                padding-top: 10px;
                text-align: center;
                button {
                    letter-spacing: 2px;
                }
            }
        }
    }
</style>
